import { render, staticRenderFns } from "./Company_select_obj.vue?vue&type=template&id=52019b94"
import script from "./Company_select_obj.vue?vue&type=script&lang=js"
export * from "./Company_select_obj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports